import React from 'react'
import {Route, Switch} from 'react-router-dom'
import AuditLanding from './AuditLanding'

export default function Routes(props) {
  return (
    <div>
      <Switch>
        <Route exact path="/audits" component={AuditLanding} />
        <Route exact path="/audits/:id" component={AuditLanding} />
        <Route exact path="/audits/:id/items/:itemId" component={AuditLanding} />
      </Switch>
    </div>
  )
}
